
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Download, FileSpreadsheet } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import * as XLSX from 'xlsx';

const EcommerceUploadTemplate: React.FC = () => {
  const { toast } = useToast();

  const downloadTemplate = () => {
    try {
      // Create sample data for the template
      const templateData = [
        {
          'Date': '2024-01-15',
          'Product Name': 'Tomato',
          'Price': 25.50,
          'Location': 'Online Store A',
          'Product Remark': 'Fresh organic tomatoes'
        },
        {
          'Date': '2024-01-15',
          'Product Name': 'Onion',
          'Price': 18.75,
          'Location': 'E-commerce Platform B',
          'Product Remark': 'Red onions - premium quality'
        },
        {
          'Date': '2024-01-16',
          'Product Name': 'Potato',
          'Price': 12.00,
          'Location': 'Digital Marketplace C',
          'Product Remark': ''
        }
      ];

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(templateData);

      // Set column widths
      ws['!cols'] = [
        { width: 12 }, // Date
        { width: 20 }, // Product Name
        { width: 10 }, // Price
        { width: 25 }, // Location
        { width: 30 }  // Product Remark
      ];

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Ecommerce Prices');

      // Save file
      XLSX.writeFile(wb, 'ecommerce_prices_template.xlsx');

      toast({
        title: 'Template Downloaded',
        description: 'Excel template has been downloaded successfully',
      });
    } catch (error) {
      console.error('Error generating template:', error);
      toast({
        title: 'Error',
        description: 'Failed to generate template file',
        variant: 'destructive',
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileSpreadsheet className="h-5 w-5" />
          Excel Template
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-gray-600">
          Download the Excel template with the correct format for uploading ecommerce prices.
          The template includes sample data to guide you.
        </p>
        
        <div className="bg-gray-50 p-4 rounded-lg">
          <h4 className="font-medium mb-2">Required Columns:</h4>
          <ul className="text-sm text-gray-600 space-y-1">
            <li><strong>Date:</strong> Date in YYYY-MM-DD format (e.g., 2024-01-15)</li>
            <li><strong>Product Name:</strong> Name of the product</li>
            <li><strong>Price:</strong> Price as a number (e.g., 25.50)</li>
            <li><strong>Location:</strong> Ecommerce platform or store name</li>
            <li><strong>Product Remark:</strong> Optional additional information</li>
          </ul>
        </div>

        <Button onClick={downloadTemplate} className="w-full">
          <Download className="h-4 w-4 mr-2" />
          Download Excel Template
        </Button>
      </CardContent>
    </Card>
  );
};

export default EcommerceUploadTemplate;
